/*class Source {
    constructor(id) {
      this.id = id; // ID of the source
    }
  }
  
  class Expense {
    constructor(id) {
      this.id = id; // ID of the expense
    }
  }
  
  class DetailMovement {
    constructor(serialNumber, remarque = null) {
      this.serialNumber = serialNumber; // Serial number of the detail
      this.remarque = remarque; // Optional remark
    }
  }
  
  class ExpenseMovement {
    constructor(expense, value, remarque = null) {
      this.expense = new Expense(expense.id); // Reference to Expense object
      this.value = value; // Value of the expense
      this.remarque = remarque; // Optional remark
    }
  }
  
  class Movement {
    constructor(
      e_s,
      date,
      nombre,
      poidTot,
      prixTot,
      source,
      remarque = null,
      addDetailMovement = false,
      detailMovements = [],
      expenseMovements = []
    ) {
      this.e_s = e_s; // 'Entry' or 'Exit'
      this.date = date; // Movement date
      this.nombre = nombre; // Quantity
      this.poidTot = poidTot; // Total weight
      this.prixTot = prixTot; // Total price
      this.source = new Source(source.id); // Reference to Source object
      this.remarque = remarque; // Optional remark
      this.addDetailMovement = addDetailMovement; // Boolean flag
      this.detailMovements = detailMovements.map(
        (detail) => new DetailMovement(detail.serialNumber, detail.remarque)
      ); // List of DetailMovement objects
      this.expenseMovements = expenseMovements.map(
        (expenseMovement) =>
          new ExpenseMovement(
            expenseMovement.expense,
            expenseMovement.value,
            expenseMovement.remarque
          )
      ); // List of ExpenseMovement objects
    }
  }*/


    export default class Movement {
      constructor(id, e_s, date, nombre, poidTot, prixTot, source, destination, remarque, addDetailMovement = false, detailMovements = [], expenseMovements = [], operation) {
        this.id = id,
        this.e_s = e_s;  // Entry or Exit
        this.date = date;
        this.nombre = nombre;
        this.poidTot = poidTot;
        this.prixTot = prixTot;
        this.source = source; // Expected format: { id: 1 }
        this.destination = destination; // Expected format: { id: 1 }
        this.remarque = remarque;
        this.addDetailMovement = addDetailMovement; // Boolean
        this.detailMovements = detailMovements; // Array of detail movement objects
        this.expenseMovements = expenseMovements; // Array of expense movement objects
        this.operation = operation;
      }
    }